import {
  MigrationPhase,
  MigrationRunStatus,
  MigrationStepStatus,
} from "@redotech/redo-support-v2-migration/execution/migration-execution-progress";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const DateString = z.string().datetime();

export const SupportV2MigrationRunProgress = z.object({
  completedAt: DateString.nullable(),
  createdAt: DateString,
  id: z.string(),
  lastError: z.string().nullable(),
  planHash: z.string(),
  requestedSteps: z.array(z.string()),
  startedAt: DateString.nullable(),
  status: MigrationRunStatus,
  updatedAt: DateString,
  workflowId: z.string(),
});
export type SupportV2MigrationRunProgress = z.infer<
  typeof SupportV2MigrationRunProgress
>;

export const SupportV2MigrationStepProgress = z.object({
  attempt: z.number(),
  checkpoint: z.unknown().nullable(),
  completedAt: DateString.nullable(),
  failedCount: z.number(),
  id: z.string(),
  insertedCount: z.number(),
  lastError: z.string().nullable(),
  phase: MigrationPhase,
  skippedCount: z.number(),
  startedAt: DateString.nullable(),
  status: MigrationStepStatus,
  totalCount: z.number(),
  updatedAt: DateString,
  updatedCount: z.number(),
  warningCount: z.number(),
});
export type SupportV2MigrationStepProgress = z.infer<
  typeof SupportV2MigrationStepProgress
>;

export const SupportV2MigrationFailureSample = z.object({
  entity: z.string(),
  error: z.string(),
  firstSeenAt: DateString,
  id: z.string(),
  lastSeenAt: DateString,
  legacyId: z.string(),
  occurrenceCount: z.number(),
  phase: MigrationPhase,
});
export type SupportV2MigrationFailureSample = z.infer<
  typeof SupportV2MigrationFailureSample
>;

export const getSupportV2MigrationProgress = {
  name: "getSupportV2MigrationProgress" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    currentStepPhase: MigrationPhase.nullable(),
    failures: z.array(SupportV2MigrationFailureSample),
    history: z.array(SupportV2MigrationRunProgress),
    run: SupportV2MigrationRunProgress.nullable(),
    steps: z.array(SupportV2MigrationStepProgress),
  }),
};
export type SupportV2MigrationProgress = z.infer<
  typeof getSupportV2MigrationProgress.output
>;
